/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAufgabeMiniListResponseDto } from '../../models/lexplus-aufgabe-mini-list-response-dto';
import { LexplusAufgabenScopeEnum } from '../../models/lexplus-aufgaben-scope-enum';

export interface AufgabenControllerFindAllPaginatedV1$Params {
  erlassIDs?: Array<number>;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by erstelltVonID query param.
 *
 * **Format:** filter.erstelltVonID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.erstelltVonID=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.erstelltVonID'?: Array<string>;

/**
 * Filter by status query param.
 *
 * **Format:** filter.status={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.status=$eq:John Doe&filter.status=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $not
 *
 * - $and
 *
 * - $or
 */
  'filter.status'?: Array<string>;

/**
 * Filter by standortID query param.
 *
 * **Format:** filter.standortID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.standortID=$eq:John Doe&filter.standortID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $null
 *
 * - $and
 *
 * - $or
 */
  'filter.standortID'?: Array<string>;

/**
 * Filter by verantwortlich query param.
 *
 * **Format:** filter.verantwortlich={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.verantwortlich=$eq:John Doe&filter.verantwortlich=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.verantwortlich'?: Array<string>;

/**
 * Filter by prioritaet query param.
 *
 * **Format:** filter.prioritaet={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.prioritaet=$eq:John Doe&filter.prioritaet=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.prioritaet'?: Array<string>;

/**
 * Filter by kundeID query param.
 *
 * **Format:** filter.kundeID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.kundeID=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.kundeID'?: Array<string>;

/**
 * Filter by parentAufgabeID query param.
 *
 * **Format:** filter.parentAufgabeID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.parentAufgabeID=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.parentAufgabeID'?: Array<string>;

/**
 * Filter by istUnteraufgabe query param.
 *
 * **Format:** filter.istUnteraufgabe={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.istUnteraufgabe=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.istUnteraufgabe'?: Array<string>;

/**
 * Filter by shortcutID query param.
 *
 * **Format:** filter.shortcutID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.shortcutID=$eq:John Doe&filter.shortcutID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.shortcutID'?: Array<string>;

/**
 * Filter by termin query param.
 *
 * **Format:** filter.termin={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.termin=$eq:John Doe&filter.termin=$gte:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $gte
 *
 * - $lte
 *
 * - $and
 *
 * - $or
 */
  'filter.termin'?: Array<string>;

/**
 * Filter by erledigtAm query param.
 *
 * **Format:** filter.erledigtAm={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.erledigtAm=$gte:John Doe&filter.erledigtAm=$lte:John Doe
 *
 * **Available Operations**
 * - $gte
 *
 * - $lte
 *
 * - $and
 *
 * - $or
 */
  'filter.erledigtAm'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=betreff:DESC&sortBy=termin:DESC
 *
 *
 * **Default Value:** termin:ASC
 *
 * **Available Fields**
 * - betreff
 *
 * - termin
 *
 * - status
 *
 * - prioritaet
 *
 * - parentAufgabeID
 *
 * - kundeID
 *
 * - erstelltAm
 *
 * - erledigtAm
 *
 * - aufgabeID
 */
  sortBy?: Array<'betreff:ASC' | 'betreff:DESC' | 'termin:ASC' | 'termin:DESC' | 'status:ASC' | 'status:DESC' | 'prioritaet:ASC' | 'prioritaet:DESC' | 'parentAufgabeID:ASC' | 'parentAufgabeID:DESC' | 'kundeID:ASC' | 'kundeID:DESC' | 'erstelltAm:ASC' | 'erstelltAm:DESC' | 'erledigtAm:ASC' | 'erledigtAm:DESC' | 'aufgabeID:ASC' | 'aufgabeID:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** betreff
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 * - betreff
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** aufgabeID,betreff,uebersetzung,status,termin
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
  scope?: LexplusAufgabenScopeEnum;
}

export function aufgabenControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: AufgabenControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAufgabeMiniListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('erlassIDs', params.erlassIDs, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.erstelltVonID', params['filter.erstelltVonID'], {});
    rb.query('filter.status', params['filter.status'], {});
    rb.query('filter.standortID', params['filter.standortID'], {});
    rb.query('filter.verantwortlich', params['filter.verantwortlich'], {});
    rb.query('filter.prioritaet', params['filter.prioritaet'], {});
    rb.query('filter.kundeID', params['filter.kundeID'], {});
    rb.query('filter.parentAufgabeID', params['filter.parentAufgabeID'], {});
    rb.query('filter.istUnteraufgabe', params['filter.istUnteraufgabe'], {});
    rb.query('filter.shortcutID', params['filter.shortcutID'], {});
    rb.query('filter.termin', params['filter.termin'], {});
    rb.query('filter.erledigtAm', params['filter.erledigtAm'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
    rb.query('scope', params.scope, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAufgabeMiniListResponseDto>;
    })
  );
}

aufgabenControllerFindAllPaginatedV1.PATH = '/v1/aufgaben/paginated/all';
